<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render (h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      if (icon.includes('ivu-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon']} />)
      } else {
        vnodes.push(<svg-icon icon-class={icon}/>)
      }
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  margin-left: 10px;
  margin-right: 6px;
  height: 1em;
}
/*sidebar-icon*/
@font-face {
  font-family: 'icomoon';
  src:  url('../../../styles/fonts/sidebar.eot?2nwv9x');
  src:  url('../../../styles/fonts/sidebar.eot?2nwv9x#iefix') format('embedded-opentype'),
  url('../../../styles/fonts/sidebar.ttf?2nwv9x') format('truetype'),
  url('../../../styles/fonts/sidebar.woff?2nwv9x') format('woff'),
  url('../../../styles/fonts/sidebar.svg?2nwv9x#icomoon') format('svg');
  font-weight: normal;
  font-style: normal;
}
.ivu-icon-home:before {
  content: "\e900";
  font-family: 'icomoon'!important;
}
.ivu-icon-star1:before {
  content: "\e904";
  font-family: 'icomoon';
}
.ivu-icon-4:before {
  content: "\e902";
  font-family: 'icomoon';
}
.ivu-icon-3:before {
  content: "\e903";
  font-family: 'icomoon';
}
.ivu-icon-heart:before {
  content: "\e905";
  font-family: 'icomoon';
}
.ivu-icon-11:before {
  content: "\e901";
  font-family: 'icomoon';
}

</style>



// WEBPACK FOOTER //
// src/mobileLayout/components/Sidebar/Item.vue